import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./TestimonialSection.css";
import Badge from "../ServiceSection/Badge";



const reviews = [
  {
    name: "Michael Thompson",
    service: "Residential Roof Repair",
    location: "Homeowner",
    text: "We had a major roof leak after a storm, and the team responded quickly. They inspected everything thoroughly and fixed the issue the same day. The quality of work was excellent, and they made sure everything was watertight before leaving. Very professional and reliable service.",
  },
  {
    name: "Sarah Williams",
    service: "Roof Replacement",
    location: "Homeowner",
    text: "Our old roof was badly worn, and we needed a full replacement. The crew explained every step clearly and completed the job on time. The new roof looks amazing and has completely improved our home’s appearance. Highly recommended for anyone needing a stress-free replacement.",
  },
  {
    name: "David Carter",
    service: "Commercial Roof Installation",
    location: "Business Owner",
    text: "We hired them for a new commercial roof installation, and the experience was smooth from start to finish. They worked around our business hours and minimized disruption. The installation quality is outstanding, and everything was completed within the promised timeline.",
  },
  {
    name: "Emily Johnson",
    service: "Roof Inspection",
    location: "Homeowner",
    text: "I requested a roof inspection after noticing some missing shingles. The inspection was detailed and honest, and they explained what needed attention without any pressure. I really appreciated their transparency and professional approach.",
  },
  {
    name: "Robert Miller",
    service: "Commercial Roof Replacement",
    location: "Business Owner",
    text: "Our facility needed a complete roof replacement, and the team handled it very efficiently. They managed the project professionally and kept us updated throughout the process. The new roofing system is durable and built to last.",
  },
  {
    name: "Jessica Brown",
    service: "Residential Roof Installation",
    location: "Homeowner",
    text: "From consultation to installation, everything was handled perfectly. The team helped us choose the right materials and completed the installation with great attention to detail. Our home looks better than ever, and we feel confident in the quality.",
  },
];

const stats = [
  { value: "4.9",  label: "Google Rating", icon: "bi-star-fill" },
  { value: "500+", label: "Projects Done",  icon: "bi-house-check-fill" },
  { value: "100%", label: "Satisfaction",   icon: "bi-shield-fill-check" },
  { value: "24h",  label: "Response Time",  icon: "bi-clock-fill" },
];

const TestimonialSection = () => {
  const allReviews = [...reviews, ...reviews];

  return (
    <section className="cs-section ts-section" style={{ backgroundColor: '#f8f9fa' }}>
      {/* Decorative shapes */}
      <div className="ts-bg-shape ts-shape-1"></div>
      <div className="ts-bg-shape ts-shape-2"></div>

      <div className="container position-relative">

        {/* Header */}
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <div className="cs-badge d-flex justify-content-center">
           <Badge className="d-flex justify-content-center text-center mx-auto" text={"Customer Feedback"}></Badge>
           </div>
            <h2 className="cs-title ts-main-heading">
              Trusted by Hundreds of <br />
              <span className="ts-red">Property Owners</span>
            </h2>
            <div className="ts-header-line"></div>
          </div>
        </div>

        {/* Infinite Slider */}
        <div className="cs-content ts-slider-wrapper">
          <div className="ts-slider-track">
            {allReviews.map((item, index) => (
              <div className="ts-review-card" key={index}>
                <div className="ts-card-top">
                  <div className="ts-quote-icon">
                    <i className="bi bi-quote"></i>
                  </div>
                  <div className="ts-stars">
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                  </div>
                </div>

                <p className="ts-review-body">"{item.text}"</p>

                <div className="ts-card-footer">
                  <div>
                    <h5 className="ts-user-name">{item.name}</h5>
                    <span className="ts-user-meta">{item.service}</span>
                    <span className="ts-user-location">{item.location}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Stats Bar */}
        <div className="row g-0 ts-stats-row mt-5">
          {stats.map((stat, idx) => (
            <div className="col-6 col-md-3" key={idx}>
              <div className="ts-stat-box">
                <i className={`bi ${stat.icon} ts-stat-icon`}></i>
                <h3 className="ts-stat-num">{stat.value}</h3>
                <p className="ts-stat-text">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default TestimonialSection;
